import { useEffect, useState } from 'react';
import { captureException } from '@sentry/react';
import { loadSmplr } from './loadSmplr';

export const useSmplrSpace = ({ spaceId, clientToken, containerId }) => {
    const [space, setSpace] = useState(null);

    useEffect(() => {
        let cancelled = false;

        loadSmplr()
            .then((smplr) => {
                if (!cancelled) setSpace(new smplr.Space({ spaceId, clientToken, containerId }));
            })
            .catch((error) => {
                if (cancelled) return;
                console.error(error);
                captureException(error);
            });

        return () => {
            cancelled = true;
        };
    }, [spaceId, clientToken, containerId]);

    return space;
};
